import { DatePicker } from 'antd';
import styled from 'styled-components';

export const CustomStyledDatePicker = styled(DatePicker)<{
  onChange?: any;
}>`
  &.ant-picker {
    border-color: ${({ theme }) => theme.colors.primary[100]} !important;
  }
  .ant-picker-suffix {
    color: ${({ theme }) => theme.colors.primary[100]} !important;
  }
  .ant-picker-input input::placeholder {
    color: #585858 !important;
  }
`;
